import { LoanRequest_SystemNoteAdded } from 'cpool-events';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const SystemNotesTableDefinitionZod = z.object({
    id: schemaId,
    notes: z.array(LoanRequest_SystemNoteAdded.prototype.getSchema().merge(z.object({ timestamp: z.number() }))),
});

export type SystemNotesTableSchema = z.infer<typeof SystemNotesTableDefinitionZod>;
